import { Component } from "@angular/core";

@Component({
    selector: "app-migrated-sinester",
    template: "<router-outlet></router-outlet>",
})
export class MigratedSinesterComponent { }



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/migrated-sinester/migrated-sinester.component.ts